import React from "react";

import { Provider } from "react-redux";

import { getAccountSettingDetails } from "./api";
import createStore from "./store";
import UserSettings from "./UserSettings";

import type { State, Action } from "./store";
import type { Store } from "redux";

type Props = {};

class App extends React.Component<Props> {
  store: Store<State, Action>;

  constructor() {
    super();
    this.store = createStore({});
  }

  componentDidMount() {
    this.store.dispatch(getAccountSettingDetails());
  }

  render() {
    return (
      <Provider store={this.store}>
        <UserSettings />
      </Provider>
    );
  }
}

export default App;
